import { forwardRef, createElement } from 'react';

function IconExportToPdf(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H12.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v8.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zM4.648 14.507l.102-.007h5l.07.003.101.017.068.019.06.023.07.035.082.054.08.07a.749.749 0 01.096.118l.05.09.04.103c.012.037.02.076.026.116l.007.102v5a.75.75 0 01-1.493.102L9 20.25v-3.19l-4.72 4.72a.75.75 0 01-1.133-.976l.073-.084L7.938 16H4.75a.75.75 0 01-.743-.648L4 15.25a.75.75 0 01.648-.743zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ExportToPdf = /*#__PURE__*/forwardRef(IconExportToPdf);

export default ExportToPdf;
//# sourceMappingURL=ExportToPdf.js.map
